<section class="passport-card-page">
  <app-banner [title]="'Votre carte de santé'"></app-banner>
  <div class="passport-card-content">
    @if (healthCards.length === 0) {
    <div class="passport-card-placeholder">
      Aucune carte de sante disponible pour le moment.
    </div>
    } @else {
    <div class="cards-grid">
      @for (card of healthCards; track card.passportNumber) {
      <app-patient-card [card]="card" (generate)="generateQrCode($event)"></app-patient-card>
      }
    </div>
    }
  </div>
</section>
